import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import logo from 'assets/images/logo.png';
import vendorBg from 'assets/images/vendor-bg.png';

const VendorLayout = () => {
    return (
        <div
            style={{
                minHeight: '100vh',
                backgroundImage: `url(${vendorBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <div className="border-bottom bg-white py-3">
                <div className="d-flex align-items-center justify-content-center gap-2">
                    <img src={logo} alt="MyKratu" height={45} />
                    <h4 className="mb-0 fw-bold">MyKratu Vendor</h4>
                </div>
            </div>

            <Container className="py-4">
                <Outlet />
            </Container>
        </div>
    );
};

export default VendorLayout;